import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const Welcome = (props) => {
    const contact = useSelector(state => {
        return (state.user.name);
    });

    return (
        <section className="flex flex-col items-start gap-8 pt-32 w-[85%] m-auto whitespace-pre-wrap">
            <h1 className="text-8xl leading-[1.35] font-bold">
                Welcome {contact}!
            </h1>
            {props.hasCompleted ? (
                <p className="text-light-grey font-light text-lg">
                    You have completed the journey. Click on the button below to view the results for your brand.
                </p>
            ) : (
                <p className="text-light-grey font-light text-lg">
                    You have just onboarded on the journey to build your purpose driven brand. <br />
                    {"\n"}
                    Grab a cup of coffee, and some chocolate maybe, and buckle up. This exercise will take some time, <br />
                    so feel free to stop at any point, and come back to it anytime during this week. <br />
                    {"\n"}
                    By the end of this week, the questionnaire will end, we'll take your answers and begin crafting your <br />
                    brand assets and guidelines!
                </p>
            )}
            <Link to={"/introduction"} className="mt-16">
                <span className="has-yellow-text flex items-center gap-12 text-7xl">
                    Let's Go!
                    <svg xmlns="http://www.w3.org/2000/svg" width="198" height="198" viewBox="0 0 198 198">
                        <g transform="translate(-489 -763)">
                            <g transform="translate(489 763)" fill="none" stroke="#fce816" strokeWidth="5">
                                <circle cx="99" cy="99" r="99" stroke="none" />
                                <circle cx="99" cy="99" r="96.5" fill="none" />
                            </g>
                            <g transform="translate(-47.5 929.216) rotate(-90)">
                                <line y2="73.093" transform="translate(66.858 597.5)" fill="none" stroke="#fce816" strokeLinecap="round" strokeWidth="5" />
                                <line x1="39.358" y2="39.358" transform="translate(66.858 634.984)" fill="none" stroke="#fce816" strokeLinecap="round" strokeWidth="5" />
                                <line x2="39.358" y2="39.358" transform="translate(27.5 634.984)" fill="none" stroke="#fce816" strokeLinecap="round" strokeWidth="5" />
                            </g>
                        </g>
                    </svg>
                </span>
            </Link>
        </section>
    )
}